import { useEffect, useState } from 'react';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);
const useLoginStatus = function() {
  const userInfo = useSelector(selectUserInfo);
  const loginStatus = !!userInfo.st;
  // const newloginStatus = window && window.CallNativeMethod('get_login_status');
  // const [loginStatus, setLoginStatus] = useState(!(newloginStatus !== '1' || !userInfo.st));

  // useEffect(() => {
  //   const newloginStatus = window && window.CallNativeMethod('get_login_status');
  //   if (!(newloginStatus !== '1' || !userInfo.st)) {
  //     setLoginStatus(true);
  //   } else {
  //     setLoginStatus(false);
  //   }
  // }, [userInfo]);
  return loginStatus;
};
export default useLoginStatus;
export const handleLogin = () => {
  if (window.CallNativeMethod) {
    window.CallNativeMethod('logout');
    window.CallNativeMethod('login');
  }
  // // eslint-disable-next-line no-unused-expressions
  // window.CallNativeMethod && window.CallNativeMethod('login'); // 未登录 调用登录弹窗
};
